{
  "remove": "Κατάργηση"
}
